import "firebase/firestore";
import "firebase/auth";

import firebase from "firebase/app";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyD-8kfAq92Im1FUm2lCqb1iWGfBsrpRbvo",
  authDomain: "casa-mosaico.firebaseapp.com",
  projectId: "casa-mosaico",
  storageBucket: "casa-mosaico.appspot.com",
  messagingSenderId: "394753579263",
  appId: "1:394753579263:web:becfc698accb5d4c0cd4ca",
  measurementId: "G-WVPYZ9VZ76",
});

// firebase components
export const db = firebaseApp.firestore();
export const auth = firebase.auth();
export const authProvider = new firebase.auth.GoogleAuthProvider();

if (window.location.hostname == "localhost") {
  db.useEmulator("localhost", 8082);
  auth.useEmulator("http://localhost:9099");
}
